import Sponsor from '@/models/Sponsor';
import { v4 as uuidv4 } from 'uuid';

export const getValidSponsors = (sponsors) => {
    const valid = [];
    for (let i in sponsors) {
        if (sponsors[i].title || '' !== '') {
            valid.push(sponsors[i]);
        }
    }

    return valid;
};

export const createSponsor = () => {
    return new Sponsor({
        id: uuidv4(),
        title: '',
        short_description: '',
        button_title: '',
        button_url: '',
        button_color: '',
        approval_number: '',
        avatar: undefined
    });
};